import React, { Component } from 'react';
import mobileVerify from '../../verification/mobile-verify.js';

class AccountSettingsMobileVerify extends Component {
	componentWillMount() {
		mobileVerify().open('get_the_code');
	}

	render() {
		return (
			<div id="account-verify-mobile-verify" />
		);
	}
}

export default AccountSettingsMobileVerify;




// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-settings-mobile-verify.js